<!-- =========================================================================================
  File Name: CompanyEditGeneralDetails.vue
  Description: Entity Edit account content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="vx-card">
    <div id="user-edit-account-details">
      <div class="vx-row">
        <div class="vx-col w-full">
          <h3>General Details</h3>
        </div>
      </div>
      <!-- Avatar Row -->
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="flex items-start flex-col sm:flex-row">
            <div>
              <label class="vs-input--label">Status</label>
              <yes-no-toggle v-model="is_enabled_local">
                <template v-slot:on>Active</template>
                <template v-slot:off>Inactive</template>
              </yes-no-toggle>
            </div>
          </div>
        </div>
      </div>

      <!-- Content Row -->
      <div class="vx-row mt-4">
        <div class="vx-col md:w-1/2 w-full">
          <vs-input class="w-full" label="Entity Name"
                    v-model="data_local.CompanyName"
                    v-validate="'required'"
                    name="CompanyName" />
          <span class="text-danger text-sm"  v-show="vErrors.has('CompanyName')">{{ vErrors.first('CompanyName') }}</span>
        </div>
        <div class="vx-col md:w-1/2 w-full">
          <vs-input class="w-full" label="Entity Code"
                    v-model="data_local.CompanyCode"
                    v-validate="'required|max:10'"
                    name="CompanyCode" />
          <span class="text-danger text-sm"  v-show="vErrors.has('CompanyCode')">{{ vErrors.first('CompanyCode') }}</span>
        </div>
      </div>

      <!-- Content Row -->
      <div class="vx-row mt-4">
        <div class="vx-col md:w-1/2 w-full">
          <label class="vs-input--label">Reporting Group</label>
          <v-select
              v-model="group_local"
              :clearable="false"
              :options="groupOptions"
              v-validate="'required'"
              name="CompanyGroup_FK"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
          />
          <span class="text-danger text-sm"  v-show="vErrors.has('CompanyGroup_FK')">{{ vErrors.first('CompanyGroup_FK') }}</span>
        </div>
        <div class="vx-col md:w-1/2 w-full">
          <label class="vs-input--label">Classification</label>
          <v-select v-model="classification_local" :clearable="false" :options="classificationOptions" v-validate="'required'" name="CompanyType_Entity_FK" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
          <span class="text-danger text-sm"  v-show="vErrors.has('CompanyType_Entity_FK')">{{ vErrors.first('CompanyType_Entity_FK') }}</span>
          </div>
      </div>

      <!-- Content Row -->
      <div class="vx-row mt-4">
        <div class="vx-col md:w-1/4 w-full">
          <label class="vs-input--label">Parent Entity (Optional)</label>
          <v-select v-model="parent_company_local" :clearable="false" :options="parentCompanyOptions" name="ParentCompany_FK" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
          <span class="text-danger text-sm"  v-show="vErrors.has('ParentCompany_FK')">{{ vErrors.first('ParentCompany_FK') }}</span>
        </div>
        <div class="vx-col md:w-1/4 w-full">
          <vs-input class="w-full" label="Entity Type (Optional)" v-model="data_local.CompanyExtension" name="CompanyExtension" v-validate="'max:20'" />
          <span class="text-danger text-sm"  v-show="vErrors.has('CompanyExtension')">{{ vErrors.first('CompanyExtension') }}</span>
        </div>
        <div class="vx-col md:w-1/2 w-full">
          <label class="vs-input--label">LLoyds Status</label>
          <v-select v-model="lloyds_status_local" :clearable="false" :options="lloydsStatusOptions" v-validate="'required'" name="CompanyType_LloydsStatus_FK" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
          <span class="text-danger text-sm"  v-show="vErrors.has('CompanyType_LloydsStatus_FK')">{{ vErrors.first('CompanyType_LloydsStatus_FK') }}</span>
        </div>
      </div>

      <div class="vx-row mt-4">
        <div class="vx-col md:w-1/4 w-full">
          <label class="vs-input--label">Previous Entity (Optional)</label>
          <v-select v-model="company_ancestor_local" :clearable="false" :options="parentCompanyOptions"
                    name="CompanyAncestor_FK"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'" />
          <span class="text-danger text-sm"  v-show="vErrors.has('CompanyAncestor_FK')">{{
              vErrors.first('CompanyAncestor_FK')
            }}</span>
        </div>
        <div class="vx-col md:w-1/4 w-full">
          <label class="vs-input--label">Producer Status (Optional)</label>
          <v-select v-model="producer_status_local" :clearable="false" :options="producerStatusOptions"
                    name="ProducerStatusType_FK"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'" />
          <span class="text-danger text-sm"  v-show="vErrors.has('ProducerStatusType_FK')">{{
              vErrors.first('ProducerStatusType_FK')
            }}</span>
        </div>
      </div>

      <!-- Content Row -->
      <div class="vx-col py-3 lg:w-full mt-4">
        <div class="py-1">
          <h5>Email Addresses</h5>
        </div>
        <additive-contact-fields
            :options="emailTypeOptions"
            v-model="emailValues"
            canSetPrimary
            @value="setEmails"
            button-label="Add email"
            validation-name="email_addresses"
            primary-input-validation-name="EmailAddress"
            primary-input-validation-type="required"
            primary-select-validation-name="EmailType_FK"
            primary-select-validation-type="required"
            ref="EmailAddresses"

        />
      </div>

    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import AdditiveContactFields from "../../../components/contact-fields/AdditiveContactFields";
import YesNoToggle from "@/views/components/extra-components/YesNoToggle";
import StringMixin from "@/components/mixins/StringMixin";

export default {
  components: {
    YesNoToggle,
    vSelect,
    AdditiveContactFields,
  },
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  mixins: [StringMixin],
  data () {
    return {
      data_local: JSON.parse(JSON.stringify(this.value)),
      emailAddresses: [],
      classifications: [],
      lloydsStatuses: [],
      producerStatuses: [],
      groups: [],
      parentCompanies: [],
      rawEmailOptions: [],
      forms: [
          'EmailAddresses',
      ]
    }
  },
  computed: {
    group_local: {
      get () {
        const group = this.groups.find(({ id }) => id === parseInt(this.data_local.CompanyGroup_FK));

        if (!group) {
          return group;
        }

        return { label: group.CompanyGroupName,  value: group.CompanyGroup_PK }
      },
      set (obj) {
        this.data_local.CompanyGroup_FK = obj.value
      }
    },
    classification_local: {
      get () {
        const classification = this.classifications.find(({ id }) => id === parseInt(this.data_local.CompanyType_Entity_FK));

        if (!classification) {
          return classification;
        }

        return { label: classification.CompanyTypeName,  value: classification.CompanyType_PK }
      },
      set (obj) {
        this.data_local.CompanyType_Entity_FK = obj.value
      }
    },
    lloyds_status_local: {
      get () {
        const lloydsstatus = this.lloydsStatuses.find(({ id }) => id === parseInt(this.data_local.CompanyType_LloydsStatus_FK));

        if (!lloydsstatus) {
          return lloydsstatus;
        }

        return { label: lloydsstatus.CompanyTypeName,  value: lloydsstatus.CompanyType_PK }


        if (!this.data_local.lloyds_status) {
          return {
            label: 'None',
            value: null
          };
        }

        return { label: this.data_local.lloyds_status.CompanyTypeName,  value: this.data_local.lloyds_status.CompanyType_PK }
      },
      set (obj) {
        this.data_local.CompanyType_LloydsStatus_FK = obj.value
      }
    },
    producer_status_local: {
      get () {
        const producerStatuses = this.producerStatuses.find(({ id }) => id === parseInt(this.data_local.ProducerStatusType_FK));

        if (!producerStatuses) {
          return producerStatuses;
        }

        return { label: producerStatuses.Type,  value: producerStatuses.id }


        if (!this.data_local.producer_status) {
          return {
            label: 'None',
            value: null
          };
        }

        return { label: this.data_local.producer_status.Type,  value: this.data_local.producer_status.id }
      },
      set (obj) {
        this.data_local.ProducerStatusType_FK = obj.value
      }
    },
    parent_company_local: {
      get () {
        if (!this.data_local.ParentCompany_FK) {
          return {};
        }

        const parentCompany = this.parentCompanies.find( item  => parseInt(item.id) === parseInt(this.data_local.ParentCompany_FK));

        if (!parentCompany) {
          return {};
        }

        return { label: this.concat(parentCompany.CompanyName, parentCompany.CompanyCode),  value: parentCompany.id }
      },
      set (obj) {
        this.data_local.ParentCompany_FK = obj.value
      }
    },
    company_ancestor_local: {
      get () {
        if (!this.data_local.CompanyAncestor_FK) {
          return {};
        }

        const company = this.parentCompanies.find( item  => parseInt(item.id) ===
            parseInt(this.data_local.CompanyAncestor_FK));

        if (!company) {
          return {
            label: 'None',
            value: null
          };
        }

        return { label: this.concat(company.CompanyName, company.CompanyCode),  value: company.id }
      },
      set (obj) {
        this.data_local.CompanyAncestor_FK = obj.value
      }
    },
    is_enabled_local: {
      get() {
        return Boolean(this.data_local.IsEnabled);
      },
      set(val) {
        this.data_local.IsEnabled = val;
      }
    },
    validateForm () {
      return !this.vErrors.any()
    },
    classificationOptions() {
      let options = this.classifications.map(({ id, CompanyTypeName }) => ({label: CompanyTypeName, value: id}));

      return [
        {
          label: 'None',
          value: 0,
        },
        ...options
      ];
    },
    lloydsStatusOptions() {
      let options = this.lloydsStatuses.map(({ id, CompanyTypeName }) => ({label: CompanyTypeName, value: id}));

      return [
        {
          label: 'None',
          value: 0,
        },
        ...options
      ];
    },
    producerStatusOptions() {
      let options = this.producerStatuses.map(({ id, Type }) => ({label: Type, value: id}));

      return [
        {
          label: 'None',
          value: 0,
        },
        ...options
      ];
    },
    groupOptions() {
      let options = this.groups.map(({ id, CompanyGroupName }) => ({label: CompanyGroupName, value: id}));

      return [
        {
          label: 'None',
          value: 0,
        },
        ...options
      ];
    },
    parentCompanyOptions() {
      let companies = this.parentCompanies
              .map(({ id, CompanyName, CompanyCode }) => ({ label: this.concat(CompanyName, CompanyCode), value: id }));
      return [
        {
          label: 'None',
          value: 0,
        },
        ...companies
      ];
    },
    emailTypeOptions() {
      return this.rawEmailOptions.map(({ id, Type}) => { return { label: Type, value: id }  });
    },
    emailValues() {
      if (!this.value || !this.value.email_addresses) {
        return [];
      }

      const values = [];

      this.value.email_addresses.map(value => {
        const settings = {
          id: value.CompanyEmailAddress_PK,
          dropdownValue: value.EmailType_FK,
          value: value.EmailAddress,
          primary: parseInt(value.IsPrimaryEmail),
        };

        values.push(settings);
      });

      return values;
    },
  },
  created() {
    this.getRelatedData();
  },
  watch: {
    data_local: {
      handler(val) {
        this.$emit('input', val);
      },
      deep: true,
    },
  },
  methods: {
    capitalize (str) {
      return str.slice(0, 1).toUpperCase() + str.slice(1, str.length)
    },
    save_changes () {
      /* eslint-disable */
      if (!this.validateForm) return

      // Here will go your API call for updating data
      // You can get data in "this.data_local"

      /* eslint-enable */
    },
    reset_data () {
      this.data_local = JSON.parse(JSON.stringify(this.data))
    },
    update_avatar () {
      // You can update avatar Here
      // For reference you can check dataList example
      // We haven't integrated it here, because data isn't saved in DB
    },
    addEmail() {
      this.emailAddresses.push({
        EmailType: 'home',
        EmailAddress: '',
      })
    },
    removeEmail({EmailType, EmailAddress}) {
      this.emailAddresses = this.emailAddresses.filter((email) => email.EmailType !== EmailType && email.EmailAddress
              !== EmailAddress);
    },
    getRelatedData() {
      this.getClassifications();
      this.getLloydsStatuses();
      this.getProducerStatuses();
      this.getGroups();
      this.getParentCompanies();
      this.getEmailTypes();
    },
    async getClassifications() {
      try {
        const { data } = await this.$api.companyTypes.list({ params: { FilterType: 1 }});
        this.classifications = data.data;
      } catch (e) {
        this.$vs.notify({
          title: 'Error occurred',
          text: 'Not able to retrieve list of classifications. Please try again.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: 'top-right'
        })
      }
    },
    async getLloydsStatuses() {
      try {
        const { data } = await this.$api.companyTypes.list({ params: { FilterType: 2 }});
        this.lloydsStatuses = data.data;
      } catch (e) {
        this.$vs.notify({
          title: 'Error occurred',
          text: 'Not able to retrieve list of lloyds statuses. Please try again.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: 'top-right'
        })
      }
    },
    async getProducerStatuses() {
      try {
        const { data } = await this.$api.companies.producerStatuses();
        this.producerStatuses = data.data;
      } catch (e) {
        this.$vs.notify({
          title: 'Error occurred',
          text: 'Not able to retrieve list of producers statuses. Please try again.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: 'top-right'
        })
      }
    },
    async getGroups() {
      try {
        const { data } = await this.$api.companyGroups.list();
        this.groups = data.data;
      } catch (e) {
        this.$vs.notify({
          title: 'Error occurred',
          text: 'Not able to retrieve list of classifications. Please try again.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: 'top-right'
        })
      }
    },
    async getParentCompanies() {
      try {
        const { data } = await this.$api.companies.all({ params: { 'whereNot[id]' : this.value.id }});
        this.parentCompanies = data.data;
      } catch (e) {
        this.$vs.notify({
          title: 'Error occurred',
          text: 'Not able to retrieve list of lloyds statuses. Please try again.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: 'top-right'
        })
      }
    },
    async getEmailTypes() {
      try {
        const { data } = await this.$api.companyEmailAddress.getOptions();
        this.rawEmailOptions = data.data;
      } catch (e) {
        console.log(e);
        this.$vs.notify({
          title: 'Error occurred',
          text: 'Not able to retrieve email type options. Please try again.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: 'top-right'
        })
      }
    },
    setEmails(val) {
      this.data_local.email_addresses = this.mapEmailData(val);
    },
    mapEmailData(val) {
      return val.map(
        ({ dropdownValue, id, primary, value }) => {
          return {
            CompanyEmailAddress_PK: id,
            EmailType_FK: dropdownValue,
            EmailAddress: value,
            IsPrimaryEmail: primary
          }
        }
      );
    }
  }
}
</script>
